import { render, staticRenderFns } from "./AlertsSetting.vue?vue&type=template&id=0b8338c0&scoped=true"
import script from "./AlertsSetting.vue?vue&type=script&lang=js"
export * from "./AlertsSetting.vue?vue&type=script&lang=js"
import style0 from "./AlertsSetting.vue?vue&type=style&index=0&id=0b8338c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8338c0",
  null
  
)

export default component.exports